import { Tag } from 'antd'

import { useLocales } from 'src/locales'

type Props = {
  isTb?: boolean
}

export const TbTag = ({ isTb }: Props) => {
  const { t } = useLocales()

  if (!isTb) return null

  return <Tag color="red">{t('common.tb')}</Tag>
}
